import { atomWithReset } from 'jotai/utils'
import * as R from 'remeda'

import {
  type Brand,
  type CustomerAttribute,
  type Question,
} from '~/hooks/useSurveyQuery'
import {
  type DataDisplayType,
  type Group,
  groups,
  type ResultViewerType,
  type SortValue,
  toGroupIndex,
} from '~/utils'

import {
  type DisplayColumnKey,
  type DisplayRowId,
  type GroupInfo,
  type GroupsDiff,
  type IndividualSortColumnKey,
  type MatrixSortColumnKey,
  type QuestionsDiffsMap,
  type SequentialSortColumnKey,
} from '../utils'

export const brand1IdAtom = atomWithReset<Brand['id'] | null>(null)
export const brand2IdAtom = atomWithReset<Brand['id'] | null>(null)
export const dataDisplayTypeAtom = atomWithReset<DataDisplayType>('percentage')
export const groupInfosAtom = atomWithReset<GroupInfo[]>([])
export const resultViewerTypeAtom =
  atomWithReset<ResultViewerType>('sequential')
export const questionIdsAtom = atomWithReset<Question['question_id'][]>([])
export const customerAttributeIdsAtom = atomWithReset<
  CustomerAttribute['id'][]
>([])
// TODO: 多言語対応の保守性に課題あり
// - 初期値が日本語固定
// - useRestoreParams/useCreateRestoringParamsで同じインスタンスを参照する必要があるため固定値を返している
// - 現状は呼び出す側(GroupCountsFiguresContainer)で多言語に変換
// - atomの初期値も動的に設定できるよう改善が必要
export const groupNameMapAtom = atomWithReset<Record<Group, string>>(
  R.mapToObj(groups, (group) => [group, `グループ${toGroupIndex(group)}`]),
)

export const sequentialSortValueAtom =
  atomWithReset<SortValue<SequentialSortColumnKey> | null>(null)
export const individualSortValueAtom =
  atomWithReset<SortValue<IndividualSortColumnKey> | null>(null)
export const matrixSortValueAtom =
  atomWithReset<SortValue<MatrixSortColumnKey> | null>(null)

export const hiddenRowIdsAtom = atomWithReset<DisplayRowId[]>([])
export const hiddenColumnKeysAtom = atomWithReset<DisplayColumnKey[]>([])

export const groupsDiffsAtom = atomWithReset<GroupsDiff[]>([])
export const questionsDiffsMapAtom = atomWithReset<QuestionsDiffsMap>({})

export const commentAtom = atomWithReset<Record<string, string>>({})

export const savedCommentAtom = atomWithReset<Record<string, string>>({})

export const groupAtom = atomWithReset<Group>('group1')
